import React from 'react';

/** Placeholder matching ProductCard's shape, shown while a listing loads. */
const ProductCardSkeleton = () => (
  <article className="ij-card ij-card--skeleton" aria-hidden="true">
    <div className="ij-card__media ij-skeleton" />
    <div className="ij-card__body">
      <span className="ij-skeleton ij-skeleton--text" style={{ width: '92%' }} />
      <span className="ij-skeleton ij-skeleton--text" style={{ width: '64%' }} />
      <span
        className="ij-skeleton ij-skeleton--text"
        style={{ width: '45%', height: '1.2em', margin: '0.5em auto' }}
      />
      <div className="ij-card__actions">
        <span className="ij-skeleton" style={{ height: 44, borderRadius: 6 }} />
      </div>
    </div>
  </article>
);

/** `count` skeleton cards, for dropping straight into `.ij-product-grid`. */
export const ProductCardSkeletonGrid = ({ count = 8 }) => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <ProductCardSkeleton key={index} />
    ))}
  </>
);

export default ProductCardSkeleton;
